import React from "react";
import { SparklesIcon } from "@heroicons/react/24/solid";

export default function CheckoutItem({
  image,
  title,
  cast,
  price,
  author,
  isSubscription,
  duration,
  duration_type,
  ppv_content,
}) {
  const isYearly =
    duration >= 300 || String(title).toLowerCase().includes("year");

  const defaultItemImage =
    "https://images.unsplash.com/photo-1499696010180-025ef6e1a8f9?w=300";

  return (
    <div className="w-full flex items-center">
      <div className="overflow-hidden rounded-2xl w-[4.5rem] h-[4.5rem] md:w-[6rem] md:h-[6rem] bg-gradient-to-br from-zinc-900 to-zinc-950 border border-zinc-800 flex items-center justify-center flex-shrink-0 shadow-lg">
        {isSubscription ? (
          <div className="w-full h-full bg-secondary/10 border border-secondary/20 rounded-2xl flex flex-col items-center justify-center text-center p-2">
            <SparklesIcon className="w-7 h-7 text-secondary mb-1" />
            <span className="text-[10px] font-extrabold uppercase text-secondary tracking-widest">
              VIP
            </span>
          </div>
        ) : (
          <img
            src={image || defaultItemImage}
            alt={title || "Item"}
            className="object-cover object-center w-[4.5rem] h-[4.5rem] md:w-[6rem] md:h-[6rem]"
          />
        )}
      </div>

      <div className="flex-grow pl-3 md:pl-5">
        <h6 className="font-bold text-sm md:text-xl md:mr-8 mr-4 text-white">
          {title || "BAB Digital Content"}
        </h6>
        <div className="flex items-center gap-2 mt-1">
          <p className="text-zinc-400 text-xs md:text-sm font-normal">
            {isSubscription
              ? isYearly
                ? "360 Days / 1 Year Full VIP Access (Ad-Free)"
                : "30 Days / 1 Month Full VIP Access (Ad-Free)"
              : author || cast || "BAB Digital Content"}
          </p>
          {!isSubscription && ppv_content === "Yes" && (
            <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-purple-500/20 text-purple-300 border border-purple-500/30">
              PPV Rental
            </span>
          )}
        </div>
      </div>

      <div className="text-right">
        <span className="font-extrabold text-secondary text-base md:text-2xl">
          ${price}
        </span>
      </div>
    </div>
  );
}

